import ArrowButton from '@/components/molecules/arrowButton'
import Address from './address'
import Map from './map'

const RightContent = ({ map, address, ctaButton }) => {
  const base =
    'w-full max-w-[620px] flex flex-col gap-y-smallMobile lg:gap-y-smallDesktop'

  return (
    <div className={base}>
      <Map map={map} />
      <Address text={address} />
      <ArrowButton
        name={ctaButton.name}
        link={ctaButton.link}
        target="_blank"
        size="big"
        className="mx-auto lg:m-0"
      />
    </div>
  )
}

export default RightContent
